<template>
  <div>
    <datatable
      title="Tags"
      @delete="deleteTag"
      @create="createTag"
      @edit_click="editClick"
      :fields="fields"
      :response="tag_list">
    </datatable>
  </div>
</template>
<script>
// imports
import { mapActions, mapMutations, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
// constants
import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/tag_list/types'
// exports
export default {
  name: 'tag-list',
  created: function () {
    this[FETCH_ALL]()
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'Tag',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    ...mapState(STORE_NAMESPACE, ['tag_list'])
  },
  methods: {
    deleteTag (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.full_name,
        item_name: delete_data.full_name,
        method: 'deleteTag',
        method_params: { user_id: delete_data.user_id, id: delete_data.id }
      })
    },
    createTag () {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminTagForm',
        is_create: true,
        modal_title: 'Create new Tag'
      })
    },
    editClick (data) {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminTagForm',
        data,
        modal_title: 'Edit Tag'
      })
    },
    ...mapMutations('modals', ['create']),
    ...mapActions(STORE_NAMESPACE, [FETCH_ALL])
  },
  components: {
    datatable: DataTable
  }
}
</script>
